export enum ECurrencyType {
  KRW = 'KRW',
  USD = 'USD',
  SGD = 'SGD',
  INR = 'INR',
  VND = 'VND',
  IDR = 'IDR',
  MYR = 'MYR',
  CNY = 'CNY',
  JPY = 'JPY',
}

export enum ENotificationType {
  Error = 'error',
  Success = 'success',
}

export enum EUserLanguage {
  Korean = 'ko',
  English = 'en',
}

export enum EUserType {
  Mentor = 'mentor',
  Mentee = 'mentee',
  Kaitus = 'kaitus',
  Kaitus_LG = 'kaitus_lg',
  Kaitus_DN = 'kaitus_dn'
}

export enum EEmploymentType {
  FullTime = 'fulltime',
  PartTime = 'parttime',
}

export enum EWorkCareer {
  Junior = 'junior',
  Senior = 'senior',
}

export enum EDegreeType {
  Bachelor = 'bachelor',
  Master = 'master',
  Doctor = 'doctor',
  MBA = 'mba',
}

export enum ECountryType {
  KR = 'KR',
  US = 'US',
  UK = 'UK',
  CN = 'CN',
  JP = 'JP',
  ETC = 'ETC',
}

export enum ESignupPath {
  Search = '네이버 / 구글검색',
  Blog = '컨설팅 관련 블로그',
  Community = '카카오톡 / 페이스북 페이지 등 커뮤니티',
  Introduce = '지인 소개',
  ETCCheck = '기타 (입력)',
}

export enum EInterestedService {
  Onetime = '1회권',
  Regular = 'Career Step 정규반',
  MockInterview = 'Mock Interview Package',
  Intern = 'Intern Package',
}

export enum ECustomerInquiryCategory {
  Mentoring = 'mentoring',
  General = 'general',
}

export enum ERecruitmentCategory {
  Fulltime = 'permanent',
  Parttime = 'parttime',
  TurnOver = 'turnover',
}

export enum EOperation {
  View = 'view',
  Create = 'create',
  Edit = 'edit',
}

export enum EEmailType {
  Worker = 'worker',
  Coworker = 'coworker',
}

export enum EPayMethod {
  Card = 'card',
  Trans = 'trans',
}

export enum EJobType {
  Current = 'current',
  Former = 'former',
}

export enum EPositionType {
  Junior = 'junior',
  Leadership = 'leadership',
}

export enum EAvailableTimeTypes {
  Today = 'today',
  SevenDays = '7days',
  FourteenDays = '14days',
}

export enum EQuestionCategory {
  SignIn = 'sign_in',
  Mentoring = 'mentoring',
  Program = 'program',
  Content = 'content',
  Voucher = 'voucher',
  Tech = 'tech',
  ETC = 'etc',
}

export enum EBoardType {
  Announcement = 'announcement',
  CSLabContent = 'cslab_content',
  CSWebinar = 'cs_webinar',
  Recruitment = 'recruitment',
}

export const EmployedTypes = [
  { value: 'fulltime', text: '정규직' },
  { value: 'intern', text: '인턴' },
];

export const RegionTypes = [
  { value: 'asia', text: '아시아' },
  { value: 'europe', text: '유럽' },
  { value: 'usa', text: '미국' },
];

export const LibraryCompanies = [
  { value: 'bcg', text: 'BCG' },
  { value: 'bain', text: 'Bain' },
  { value: '2nd tier', text: '2nd Tier' },
  { value: 'others', text: 'Others' },
];

export const payMethods = [
  // { value: 'naverpay', icon: 'naver' },
  // { value: 'kakaopay', icon: 'kakao' },
  { value: 'card', text: '신용카드' },
  { value: 'trans', text: '계좌이체' },
];

export const StatusTypes = [
  { value: 'answered', text: '응답완료' },
  { value: 'unanswered', text: '미응답' },
];

export const IsAnsweredTypes = [
  { value: 'True', text: '응답완료' },
  { value: 'False', text: '미응답' },
];
